<p-dialog
  [visible]="_display"
  (visibleChange)="visibilityChange()"
  [style]="{ maxWidth: '700px', width: '100%', margin: '20px' }"
  [dismissableMask]="true"
  [modal]="true"
  [ngStyle]="{ borderRadius: modalService.title ? '0 0 5px 5px' : '5px' }"
  [draggable]="true"
  [resizable]="false"
  [styleClass]="className + (modalService.title ? '' : ' no-header-padding')"
  (onHide)="close.emit()"
  [header]="modalService.title">
  <ng-template #insertPoint></ng-template>
</p-dialog>
